import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class SharedService {
  private backgroundColor:any;

  constructor() {}

  setBackgroundColor(val) {
    this.backgroundColor = val;
    return true;
  }

  getVal(val) {
    return this[val];
  }
}




// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/shared.service.ts